import { RestfulClient, Session } from '@benzinga/session';
import { GptSearchEnvironment } from './environment';
import { GptConfigParameters } from './entity';
import { SafePromise } from '@benzinga/safe-await';

export class GptSearchRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(GptSearchEnvironment).url, session, { 'x-device-key': false });
  }

  public getScannerConfig = async <T extends object>(config: GptConfigParameters<T>): SafePromise<T> => {
    const url = this.URL('/api/v1/editorial/ai/scanner-gpt');
    return this.post(url, { ...config });
  };

  public getNewsFeedConfig = async <T extends object>(config: GptConfigParameters<T>): SafePromise<T> => {
    const url = this.URL('/api/v1/editorial/ai/newsfeed-gpt');
    return this.post(url, { ...config });
  };
}
